import React, { useEffect } from "react";
import { useModal } from "../Common/Hooks/useModal";
import { Play } from "../Common/SI";

import './PlayBlock.css'
import { PlayCard } from "./PlayCard";

export interface PlayBlockProps {
	play: Play
}

export function PlayBlock(props: PlayBlockProps): JSX.Element {

	const { modalBackgroundVisible, showModalBackground } = useModal()

	const [cardVisible, setCardVisible] = React.useState<boolean>(false)

	useEffect(() => {
		if (!modalBackgroundVisible) {
			setCardVisible(false)
		}
	}, [modalBackgroundVisible])

	function openCard(): void {
		setCardVisible(true)
		showModalBackground()
	}

	let summary = `${props.play.dateTimeString}   #${props.play.number}`

	const items = props.play.adversaries.map(adversary => `${adversary.name} ${adversary.level}`)
	if (props.play.scenario) {
		items.push(props.play.scenario)
	}
	if (props.play.additionalBoards === 1) {
		items.push('+1 board')
	} else if (props.play.additionalBoards > 1) {
		items.push(`+${props.play.additionalBoards} boards`)
	}
	if (items.length > 0) {
		summary += `\n` + items.join(', ')
	}

	summary += `\nDifficulty ${props.play.difficulty}\n${props.play.spirits.map(spirit => spirit.spirit.nickname).join(', ')}`

	if (props.play.islandState) {
		summary += `\n${props.play.islandState.healthy ? 'Healthy' : 'Blighted'}`
		if (props.play.islandState.blightCards.length > 0) {
			summary += ` (${props.play.islandState.blightCards.join(', ')})`
		}
	}

	return (
		<div className="play-block-wrapper">
			{
				cardVisible && (
					<React.Fragment>
						<div className="callout-container">
							<div className="callout-wrapper">
								<PlayCard play={props.play} alwaysExpanded={true} />
							</div>
						</div>
					</React.Fragment>
				)
			}
			<div
				className={`play-block difficulty-${Math.floor(props.play.difficulty || 0)} ${props.play.outcome.victory ? 'victory' : 'loss'}`}
				onClick={() => openCard()}
				title={summary}
			></div>
		</div>
	)
}
